import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import customerGroupEndpoints from '../api/customerGroupEndpoints'
import customerGroupQueryKeys from '../queries/customerGroupQueryKeys'
import integrationRequest from '../../../services/api/integrationRequest'
import { CustomerGroup } from '../../../types/customer/customer'

export const getCustomerGroups = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof customerGroupQueryKeys)['list']>>): Promise<CustomerGroup[]> => {
  if (!companyId || companyId === 'undefined') return []
  return integrationRequest<CustomerGroup[]>({
    method: GET,
    url: customerGroupEndpoints.accounting(),
    signal,
    params: {
      companyId
    }
  })
}
